import sillyname from "sillyname";
import { Graph, Link, Node } from "../models";

const getMinOrMaxPropertyHelper = <T, U>(
  arr: T[],
  prop: string,
  type: "min" | "max"
): U => {
  return arr.reduce((m: any, item: any) => {
    const value = item[prop];

    if (!m) return value;

    if (type === "min" && value < m) return value;
    if (type === "max" && value > m) return value;

    return m;
  }, undefined);
};

export const getMinProperty = <T, U>(arr: T[], prop: string): U =>
  getMinOrMaxPropertyHelper<T, U>(arr, prop, "min");

export const getMaxProperty = <T, U>(arr: T[], prop: string): U =>
  getMinOrMaxPropertyHelper<T, U>(arr, prop, "max");

export const getEquationOfLineFromTwoPoints = (point1: any, point2: any) => {
  const equation: any = {
    gradient: (point1.y - point2.y) / (point1.x - point2.x),
  };
  let parts;

  equation.yIntercept = point1.y - equation.gradient * point1.x;
  equation.toString = () => {
    if (Math.abs(equation.gradient) === Infinity) {
      return `x = ${point1.x}`;
    }
    parts = [];

    if (equation.gradient !== 0) {
      parts.push(`${equation.gradient}x`);
    }

    if (equation.yIntercept !== 0) {
      parts.push(equation.yIntercept);
    }

    return `y = ${parts.join(" + ")}`;
  };

  return equation;
};

export const floatToFixedIfNeeded = (number: number): string =>
  number.toFixed(2).replace(/[.,]00$/, "");

export const getFirstSillyName = () =>
  sillyname().split(" ")[Math.round(Math.random())];

export const getRandomInt = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const getDistance = (a: any, b: any): number =>
  Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);

export const getExampleGraphJSON = (initialI: number, initialJ = 7) => {
  // return HARCODED_GRAPH;

  const nodes: any[] = [];
  const links: any[] = [];

  const usedNames: string[] = [];

  for (let i = 0; i < initialI; i += 1) {
    for (let j = 0; j < initialJ; j += 1) {
      let name: string;
      do {
        name = getFirstSillyName();
      } while (usedNames.includes(name));
      usedNames.push(name);

      const weight = getRandomInt(1, 100);
      const x = getRandomInt(125 * i + 20, 125 * (i + 1) - 20);
      const y = getRandomInt(125 * j + 20, 125 * (j + 1) - 20);
      const node = { name, weight, x, y };
      nodes.push(node);
    }
  }

  nodes.forEach((node) => {
    const destinations = nodes.map((nd) => {
      const distance = nd.name === node.name ? Infinity : getDistance(node, nd);
      return { name: nd.name, distance };
    });

    destinations.sort((a, b) => a.distance - b.distance);

    destinations.slice(0, 3).forEach((destination) => {
      const start = node.name;
      const end = destination.name;
      const length = getRandomInt(1, 1000);

      const link = { start, end, length };
      links.push(link);
    });
  });

  return { nodes, links };
};

export const getStartAndEndNodes = (
  gameGraph: Graph,
  difficulty: number
): Node[] => {
  const visitedNodes: string[] = [];

  const startNode =
    gameGraph.nodeArray[Math.floor(Math.random() * gameGraph.nodeArray.length)];
  let endNode = startNode;
  let path: Link;
  for (let i = 0; i < difficulty; i++) {
    do {
      path = endNode.paths[Math.floor(Math.random() * endNode.paths.length)];
      const pathFinder = endNode.paths.map((p) => p.toNodeName);
      if (pathFinder.every((val) => visitedNodes.includes(val))) break;
    } while (visitedNodes.includes(path.toNodeName));

    endNode =
      gameGraph.nodeArray.find((node) => node.name === path.toNodeName) ||
      endNode;

    visitedNodes.push(endNode.name);
  }
  return [startNode, endNode];
};
